import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

export function KeyMetric({
  name,
  value,
  loading,
  href,
  onClick,
  size = "medium",
}: {
  name: string;
  value: number | string | undefined;
  loading: boolean;
  href?: string;
  onClick?: () => void;
  /** Small is the callout size, for metrics that sit beside other content. */
  size?: "medium" | "small";
}) {
  const theme = useTheme();
  const isClickable = !!href || !!onClick;
  const small = size === "small";

  return (
    <Box
      component={href ? Link : "div"}
      to={href ?? ""}
      preventScrollReset={true}
      onClick={onClick}
      sx={{
        textDecoration: "none",
        cursor: isClickable ? "pointer" : "default",
        py: small ? 1 : 1.25,
        px: 1.5,
        borderRadius: 1,
        backgroundColor:
          theme.palette.mode === "light" ? theme.palette.grey[50] : theme.palette.grey[900],
        border: `1px solid ${theme.palette.divider}`,
        transition: "all 0.15s ease-in-out",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: small ? "flex-start" : "center",
        minWidth: 0,
        overflow: "hidden",
        "&:hover": isClickable
          ? {
              backgroundColor: theme.palette.action.hover,
              borderColor: theme.palette.action.selected,
              transform: "translateY(-1px)",
            }
          : {},
      }}
    >
      <Typography
        variant={small ? "h6" : "h5"}
        fontWeight={small ? 600 : 700}
        color={theme.palette.text.primary}
        lineHeight={1.1}
      >
        {loading ? <Skeleton variant="text" width={35} height={small ? 24 : 32} /> : (value ?? 0)}
      </Typography>
      <Typography
        variant="caption"
        color={theme.palette.text.secondary}
        lineHeight={1.3}
        noWrap
        sx={{ mt: small ? 0.25 : 0.5 }}
      >
        {name}
      </Typography>
    </Box>
  );
}
